'use client';

import Image from 'next/image';
import { useState } from 'react';

export interface GalleryImage { url: string; alt: string }

// First image is the LCP element on every PDP, so it is `preload`ed (Next 16's
// name for the old `priority`). Thumbnails are small-size srcset images.
export function ProductGallery({ images, name }: { images: GalleryImage[]; name: string }) {
  const [activeIdx, setActiveIdx] = useState(0);
  const active = images[activeIdx];

  return (
    <div className="space-y-4">
      <div className="relative aspect-square bg-white overflow-hidden">
        {active ? (
          <Image
            key={active.url}
            src={active.url}
            alt={active.alt || name}
            fill
            preload={activeIdx === 0}
            sizes="(min-width: 768px) 50vw, 100vw"
            className="object-contain p-[10%]"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <p className="text-xs uppercase tracking-[0.14em] text-ink/70">Photography pending</p>
          </div>
        )}
      </div>

      {images.length > 1 && (
        <div className="grid grid-cols-4 gap-3">
          {images.slice(0, 4).map((img, i) => (
            <button
              key={img.url}
              type="button"
              onClick={() => setActiveIdx(i)}
              aria-label={`View image ${i + 1}`}
              aria-pressed={i === activeIdx}
              className={`relative aspect-square bg-white overflow-hidden transition-opacity ${
                i === activeIdx ? 'opacity-100 ring-1 ring-ink' : 'opacity-60 hover:opacity-100'
              }`}
            >
              <Image src={img.url} alt="" fill sizes="(min-width: 768px) 12vw, 24vw" className="object-contain p-[8%]" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
